import React, { useEffect, useRef, useState } from 'react';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`ease-luxe transition-[opacity,transform] duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'} ${className}`} style={delay ? {
    transitionDelay: `${delay}s`
  } : undefined} data-id="element-226" data-mp="80dxa7ilem9x">
      {children}
    </div>;
}